import { useLanguage } from '@/contexts/LanguageContext';
import { useMaintenanceMode } from '@/hooks/useMaintenanceMode';
import hausLogo from '@/assets/haus-logo-white.png';

export const MaintenanceGate = ({ children }: { children: React.ReactNode }) => {
  const { language } = useLanguage();
  const { isMaintenance, loading, settings } = useMaintenanceMode();

  if (loading) return <>{children}</>;
  if (!isMaintenance) return <>{children}</>;

  const title =
    (language === 'lv' ? settings?.title_lv : language === 'ru' ? settings?.title_ru : settings?.title_en) ||
    'Under construction';
  const message =
    (language === 'lv' ? settings?.message_lv : language === 'ru' ? settings?.message_ru : settings?.message_en) || '';

  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center px-6">
      <main className="max-w-xl w-full text-center">
        <img src={hausLogo} alt="HAUS" className="h-12 mx-auto mb-10 object-contain" />
        <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/40 to-transparent mb-10" />
        <h1 className="font-display text-2xl md:text-3xl tracking-[0.2em] uppercase text-gold mb-6">
          {title}
        </h1>
        <p className="text-cream/70 leading-relaxed">{message}</p>
        <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/40 to-transparent mt-10 mb-6" />
        <p className="text-cream/50 text-sm">
          <a href="mailto:haus@royal-bathrooms.com" className="hover:text-gold transition-colors">
            haus@royal-bathrooms.com
          </a>
          <span className="mx-2">·</span>
          <a href="tel:+37167376780" className="hover:text-gold transition-colors">+371 6737 6780</a>
        </p>
      </main>
    </div>
  );
};
